import { createTheme, ThemeProvider } from "@mui/material";
import React from "react";
import Header from "./Header";
import UserNotification from "./UserNotification/UserNotification";

const darkTheme = createTheme({
    palette: {
        mode: 'light',
      },
})

export function Page(props: React.PropsWithChildren) {
    return (
        <ThemeProvider theme={darkTheme}>                
            {props.children}
            <UserNotification />
        </ThemeProvider>
    ); 
}